import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route } from 'react-router-dom';
import App from 'localcomponents/App';
import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';

import 'antd/dist/antd.css';
import 'global.css';

import Portal from 'containers/Portal';
import Login from 'containers/Login';

class Root extends React.Component {
	render() {
		return (
			<Router>
				<App>
					<Route exact path="/" component={Login} />
					<Route path="/portal" component={Portal} />
				</App>
			</Router>
		);
	}
}


ReactDOM.render(
	<LocaleProvider locale={enUS}><Root /></LocaleProvider>,
	document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js